<template>
	<div class="footer">
		<div class="footer-description">
			Contact us:
			<a
				class="link"
				href="mailto:support@redir.love"
			>
				support@redir.love
			</a>
			<router-link
				:to="{ name: 'DataProtection' }"
				class="link"
			>
				Data Protection
			</router-link>
			<router-link
				:to="{ name: 'Imprint' }"
				class="link"
			>
				Imprint
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TheFooter',
};
</script>

<style lang="scss" scoped>
.footer {
	width: 100%;
	color: $color-accent-400;
	position: relative;
	z-index: 1;

	.footer-description {
		display: flex;
		align-content: flex-end;
		justify-content: flex-end;
		padding: $gap-25 $gap-5;
		font-size: $size-7;

		a.link {
			color: $color-primary-100;
			margin: 0 $gap-1;
		}

		.link:not(:last-child):after {
			content: '•';
			color: $color-accent-400;
			margin-left: $gap-1;
		}
	}
}
</style>
